
import React from 'react';
import { Twitter, Instagram, Send, Globe } from 'lucide-react';
import { Language } from '../App';

const Footer: React.FC<{ lang: Language }> = ({ lang }) => {
  const socialLinks = [
    { Icon: Send, href: "https://t.me/defibankofficial" },
    { Icon: Instagram, href: "https://instagram.com/defibankoficial" },
    { Icon: Twitter, href: "http://x.com/defibankoficial" },
    { Icon: Globe, href: "https://defibank.digital/" }
  ];

  return (
    <footer className="bg-black border-t border-white/5 pt-20 pb-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex flex-col items-center text-center mb-16">
          <div className="mb-8">
            <a 
              href="https://defibank.digital" 
              className="flex items-center hover:opacity-80 transition-opacity"
            >
              <img 
                src="https://i.imgur.com/VYool5N.png" 
                alt="DeFi Bank Logo" 
                className="h-10 w-auto object-contain"
              />
            </a>
          </div>
          <p className="text-zinc-500 font-medium max-w-sm mb-10 leading-relaxed">
            {lang === 'pt' 
              ? 'A infraestrutura definitiva para tokens Web3 que buscam utilidade real no mercado latino-americano.'
              : 'The ultimate infrastructure for Web3 tokens seeking real utility in the Latin American market.'}
          </p>
          <div className="flex gap-4">
            {socialLinks.map(({ Icon, href }, i) => (
              <a 
                key={i} 
                href={href} 
                target="_blank" 
                rel="noopener noreferrer"
                className="p-4 bg-zinc-950 rounded-2xl text-zinc-600 hover:text-white hover:border-red-500/30 transition-all border border-white/5"
              >
                <Icon size={20} />
              </a>
            ))}
          </div>
        </div>
        
        <div className="border-t border-white/5 pt-12 flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-zinc-700 text-[10px] font-black uppercase tracking-[0.3em]">
            © 2024 DeFi Bank Digital Group. Built for the Next Billion.
          </p>
          <div className="flex gap-8">
            <a href="#" className="text-zinc-700 hover:text-zinc-400 text-[10px] font-black uppercase tracking-[0.3em] transition-colors">
              {lang === 'pt' ? 'Política de Privacidade' : 'Privacy Policy'}
            </a>
            <a href="#" className="text-zinc-700 hover:text-zinc-400 text-[10px] font-black uppercase tracking-[0.3em] transition-colors">
              {lang === 'pt' ? 'Auditoria de Segurança' : 'Security Audit'}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
